import app from '../../../scripts/app';
import { getLkLink } from '../../../scripts/utils';
import template from './ad-submit-buttons.jade';
import { isDealRent } from "../../../scripts/services/rent-deal.service";
import { trackSendClick, trackTryToSend, trackPublishByMoneyFailed } from './AdSubmitButtons.tracking';
import { selectAnalyticsProduct } from '../../../../../shared/selectors/analytics';
import { selectIsPublishedOffer } from '../../../../../shared/selectors/offer';
import {
  trackPublishWithVisibleViolationsClick,
} from '../../../../../shared/components/VisibleViolationsWarning/VisibleViolationsWarning.tracking';

app.directive('cianAfAdSubmitButtons', [
  'pubAvailService', 'placingTermsApi', 'retryService', 'addFormLayoutService', 'addFormService',
  'hiddenBaseService', '$rootScope', 'popupService', 'userIdentificationService', 'jkService', 'bsCenterService',
  'geoService', 'deviceService', 'store',
  function (
    pubAvailService, placingTermsApi, retryService, addFormLayoutService, addFormService,
    hiddenBaseService, $rootScope, popupService, userIdentificationService, jkService, bsCenterService, geoService,
    deviceService, store
  ) {
    return {
      template,
      scope: {},
      bindToController: {
        ad: '=',
        form: '=',
        termsIsFailed: '=',
      },
      controller: [function () {
        this.placingTermsApi = placingTermsApi;
        this.pubAvailService = pubAvailService;

        this.isMobile = deviceService.isMobile;

        this.isMobileSupportVisible = () => {
          const geoLocation = addFormService.ad.geo;
          const isNiNo = geoLocation &&
            geoLocation.userInput &&
            geoLocation.userInput.toLowerCase().includes('нижний новгород');

          return this.isMobile &&
          geoService.userGeo &&
          addFormService.ad.isByHomeowner &&
          (geoService.userGeo.id === 4596 || isNiNo);
        };

        this.draftAd = () => {
          this.ad.status = 'draft';
        };

        this.isPaidAd = () => {
          return !hiddenBaseService.isEnabled() &&
            placingTermsApi.checkServiceData &&
            placingTermsApi.checkServiceData.actionDescription &&
            !isDealRent();
        };

        this.publishAd = ($event) => {
          const { isShortForm } = addFormLayoutService;
          const { option } = placingTermsApi.selected;
          const state = store.getState();

          const isPublishedOffer = selectIsPublishedOffer(state);

          if (placingTermsApi.isSubscriptionOption(option)) {
            if ($event) {
              $event.preventDefault();
              $event.stopPropagation();
            }

            popupService.openPopup('PackageBuyConfirmationModal');

            return false;
          }

          if (!isPublishedOffer) {
            trackSendClick(this.getPublishButtonText() === 'Разместить и оплатить', isShortForm);
          }

          if (placingTermsApi.shouldPayByCard()) {
            if ($event) {
              $event.preventDefault();
              $event.stopPropagation();
            }

            placingTermsApi.showRefillAccountPopup('add_offer');

            trackPublishByMoneyFailed({ isShortForm, offerId: this.ad.id });

            return false;
          }

          trackTryToSend(isShortForm, this.ad.category);

          // отменяем запрос к чек-сервису, чтобы при задержках не показывать ошибку и не менять текст кнопки после сабмита
          placingTermsApi.cancelCheckServiceRequest();

          this.ad.status = 'published';

          return true;
        };

        this.showRetryNotice = retryService.showRetryNotice;
        this.runRetry = retryService.runRetry;

        this.adStatusText = this.ad.id ? 'редактирование' : 'публикацию';

        // текст кнопки "разместить" берется из сервиса check-service, при ошибках - дефолтное значение
        this.getPublishButtonText = () => {
          const state = store.getState();

          const isPublishedOffer = selectIsPublishedOffer(state);

          if (this.isPaidAd()) {
            return placingTermsApi.checkServiceData.actionDescription;
          } else {
            return isPublishedOffer ? 'Сохранить изменения' : 'Разместить';
          }
        };

        this.showPremoderationError = false;

        this.handleSkipPremoderationErrorsClick = () => {
          const state = store.getState();

          const analyticsProduct = selectAnalyticsProduct(state);

          trackPublishWithVisibleViolationsClick(analyticsProduct);

          popupService.openPopup('premoderationConfirm');
        };

        this.publishIdentificationAd = () => {
          const isShortForm = addFormLayoutService.isShortForm;

          trackSendClick(false, isShortForm);
          userIdentificationService.setIsSaveInProcess(true);
          this.draftAd();
        };

        this.isPublishButtonAvailable = () =>
          hiddenBaseService.isEnabled() ||
          (pubAvailService.isAvailable &&
           (placingTermsApi.terms.isAvailable || isDealRent()) &&
           !this.showRetryNotice()
          );

        this.isPublishButtonDisabled = () =>
          (this.termsIsFailed && !hiddenBaseService.isEnabled()) ||
          this.form.$pending ||
          addFormService.hasBlockingActions() ||
          !!placingTermsApi.auctionBetValidate(
            placingTermsApi.auctionOption && placingTermsApi.auctionOption.dynamicPrice,
            placingTermsApi.stepBet,
            window.runtime_settings.AUTOBROKER_BET_STEP_ENABLED && typeof placingTermsApi.stepBet !== 'undefined'
          ) ||
          // Для коммерческой разрешена публикация в проблемных ЖК
          (jkService.hasProblems() && !bsCenterService.isBSCategory());

        // Возможна ли публикация с предварительной идентификацией sumsub?
        this.isPublishViaIdentificationAvailable = () => pubAvailService.isNeedIdentification && !this.showRetryNotice();

        this.getLkLink = () => getLkLink('identification');

        $rootScope.$on('premoderationErrors', (show) => {
          this.showPremoderationError = show;
        });

        $rootScope.$on('identification.runSumsub', () => {
          this.publishIdentificationAd();
          userIdentificationService.setIdentificationLink(this.getLkLink());

          $rootScope.$broadcast('publishAd');
        });

        $rootScope.$on('simulateSubmitClick', () => {
          if (this.publishAd()) {
            $rootScope.$broadcast('publishAd');
          }
        });

        this.isSubmitEnable = () => !pubAvailService.pubAvailData?.identificationInstruction?.onlyDocumentsAllowed;
        this.isSubmitWithErrorEnable = () => this.showPremoderationError && this.isSubmitEnable();
        this.isSaveDraftEnable = () => !this.ad.id || this.ad.status === 'draft';
        this.isTrySubmitOneMoreTimeEnable = () => this.showRetryNotice() && this.isSubmitEnable();
        this.isPublishEnable = () => this.isPublishButtonAvailable() && this.isSubmitEnable();
        this.isPublishViaIdentificationEnable = () =>
          !this.isPublishEnable() &&
          this.isPublishViaIdentificationAvailable() &&
          addFormService?.ad?.isByHomeowner;
      }],
      controllerAs: 'adSubmitButtons',
      replace: true,
  };
}]);
